import { IModalDescription, ViewVariant } from '@cp/shared/modal';
import { TrustworthinessModalLayoutProps } from '../trustworthinessModalLayout';

export const TRUSTWORTHINESS_MODAL: IModalDescription<TrustworthinessModalLayoutProps> = {
  nss: 'trustworthiness',
  layout: { mobile: ViewVariant.Fullscreen },
  loader: () => import('../trustworthinessModalLayout').then((module) => module.TrustworthinessModalLayout),
};
